/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import StudiesContainer from '../../components/studies/studies.container';
import DetailedTitledPage from './detailed.titled.page';
import * as consts from '../../const';

class StudiesPage extends React.Component {
  render() {
    let title = consts.STUDIES_PAGE_TITLE;
    let details = consts.STUDIES_DETAILS_TEXT;
    let content = <StudiesContainer />;
    return <DetailedTitledPage title={title} details={details} content={content} />;
  }
}

export default StudiesPage;
